/**
 * Apply key and blur events on message
 */
const ManageFocusOnKeyEvents = function (element) {
    if (element) {
        let eventFunction = (e) => {
            // Apply apexchat_element_on_focus class on tab key because we just need to show border when focus from tab key not from mouse click
            if (e.type == 'keyup' && (e.keyCode == 9 || e.code == 'tab')) {
                element.classList.add('apexchat_element_on_focus');
            }
            if (e.type == 'blur') {
                // when focus removed from element, so blue border should not appear.
                element.classList.remove('apexchat_element_on_focus');
            }
        };
        element.addEventListener('keyup', eventFunction);
        element.addEventListener('blur', eventFunction);
    }
};
export default ManageFocusOnKeyEvents;
